/**
 * Created by liwei on 16/8/25.
 * PaperController
 */

import Model from './model'
const model = new Model()
class Paper {
    /**
     * 获取考试入口url
     * @param passcode
     * @returns {*}
     */
    static getRoomEntranceUrl(passcode) {
        return model.post(`paper/open/exam?passcode=${passcode}`)
    }

}
export default Paper



// WEBPACK FOOTER //
// ./bootsets/models/paper.js